// extracted by mini-css-extract-plugin
module.exports = {"container":"HousingStockContainer_container__2RIZG","header":"HousingStockContainer_header__PpK3h","title":"HousingStockContainer_title__3Y4wY"};